import { IResponse } from "models";

export enum ActionType {
  // download PDF file TypeInfo list
  MINI_STRESS_TYPE_DOWNLOAD_PDF = "action/MINI_STRESS_TYPE_DOWNLOAD_PDF",
  MINI_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS = "action/MINI_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS",
  MINI_STRESS_TYPE_DOWNLOAD_PDF_ERROR = "action/MINI_STRESS_TYPE_DOWNLOAD_PDF_ERROR",
  MINI_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA = "action/MINI_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface MiniStressTypePDFDownloadResponse extends IResponse {
  result?: IPDFDownloadResult;
}

export interface IPDFDownloadResult {
  data: IPDFDownloadMiniStressTypeItem[];
  headers: IHeaderPDFDownloadMiniStressTypeItem[];
}
export interface IMiniStressTypeDownloadPdfData {
  not_implement: boolean;
  start_date?: string;
  end_date?: string;
  need_attention: boolean;
  high_stress_1: boolean;
  high_stress_2: boolean;
}

export interface IHeaderPDFDownloadMiniStressTypeItem {
  label: string;
  key: string;
}

export interface IPDFDownloadMiniStressTypeItem {
  name: string;
  date_of_implementation: string;
  stress_situation: string;
  status: string;
  interview_transmission_status: string;
  B: string;
  A_C: string;
  affiliation: string;
  gender: string;
}
